<template>
  <div
    v-show="loading"
    class="nt-loading"
  >
    <div class="lds-ring">
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'nt-loading',
  setup() {
    const store = useStore()
    const loading = computed(() => store.getters['appStore/loading'])

    return {
      loading,
    }
  },
}
</script>
